import { FC, useMemo } from 'react';
import styled from './index.module.scss';
import { useLang } from '@/i18n';
import { useMembersStore } from '@/components/MembersDay/MembersProvider';
interface IProps {
    type?: string;
}

const BottomTips: FC<IProps> = ({}) => {
    const { t } = useLang('membersday.teaser.BottomTips.teaser');
    const { protocol, pageStatus } = useMembersStore();

    const getContentTips = useMemo(() => {
        const content: string[] = [];
        if (protocol && Array.isArray(protocol[pageStatus]) && protocol[pageStatus].length > 0) {
            protocol[pageStatus].forEach((item: any, index: any) => {
                content.push(item.title);
                item.desc.forEach((v: string) => {
                    content.push(v);
                });
            });
        }
        return content;
    }, [protocol, pageStatus]);

    return (
        <div className={`${styled.BottomTips}`}>
            <div className="members-day-inter">
                {getContentTips.map((item, index) => (
                    <p key={index} dangerouslySetInnerHTML={{ __html: item }}></p>
                ))}
            </div>
        </div>
    );
};

export default BottomTips;
